export type AnyVanLocale = "en" | "es" | "us"


type Region = 'UK' | 'SPAIN' | 'US'

export const LOCALE: Record<Region, AnyVanLocale> = {
  UK: "en",
  US: "us",
  SPAIN: "es"
} as const

export type PlacesLocale = "GB" | "ES" | "US" | ""

export const PLACES_LOCALE: Record<Region, PlacesLocale> = {
  UK: "GB",
  US: "US",
  SPAIN: "ES"
} as const

export const LOCALE_TO_PLACES_LOCALE: Record<AnyVanLocale, PlacesLocale> = {
  en: "GB",
  us: "US",
  es: "ES"
}
